import type { CSSProperties } from "react";

export const pageTitleStyle: CSSProperties = {
	margin: 0,
	fontSize: "var(--text-title)",
	fontWeight: 600,
	letterSpacing: "var(--tracking-snug)",
	color: "var(--fg-1)",
};

export const sectionHeadingStyle: CSSProperties = {
	margin: "0 0 8px",
	fontSize: "var(--text-ui)",
	fontWeight: 600,
	color: "var(--fg-1)",
};

export const cellStyle: CSSProperties = {
	padding: "6px 8px 6px 0",
	verticalAlign: "top",
	borderTop: "1px solid var(--line-1)",
};

export function captionStyle(extra: CSSProperties = {}): CSSProperties {
	return {
		fontSize: "var(--text-caption)",
		lineHeight: "var(--leading-normal)",
		color: "var(--fg-3)",
		...extra,
	};
}
